import endpoints from "./endpoints";
import api from "./api";

export default {
  getUnits: async function (type, attributeId, languages) {
    const response = await api.get(endpoints.attributeManager[type].units.get, {
      params: { attributeId, languages }
    });
    return response.data;
  },
  getValues: async function (type, attributeId, languages) {
    const response = await api.get(endpoints.attributeManager[type].values.get, {
      params: { attributeId, languages }
    });
    return response.data;
  },
  saveUnits: async function (type, units, defaultUnitOnly, attributeId, shouldSync) {
    const response = await api.post(endpoints.attributeManager[type].units.update, {
      defaultAttributeUnits: units,
      defaultUnitOnly: defaultUnitOnly,
      shouldSync: shouldSync,
      attributeId: attributeId
    });
    return response.data;
  },
  saveValues: async function (type, values, defaultValueOnly, isMultiSelect, attributeId, shouldSync) {
    const response = await api.post(endpoints.attributeManager[type].values.update, {
      defaultAttributeValues: values,
      defaultValueOnly: defaultValueOnly,
      isMultiSelect: isMultiSelect,
      shouldSync: shouldSync,
      attributeId: attributeId
    });
    return response.data;
  },
  deleteValues: async function (type, attributeId, values) {
    const response = await api.post(endpoints.attributeManager[type].values.delete, values, { params: { attributeId } });
    return response.data;
  },
  deleteUnits: async function (type, attributeId, units) {
    const response = await api.post(endpoints.attributeManager[type].units.delete, units, { params: { attributeId } });
    return response.data;
  }
};
